'use strict';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { theme } from '../../styles/theme';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { SnackbarProvider } from 'notistack';
import { CssBaseline, Slide } from '@mui/material';
import router from '../../routes';

import { store } from '../../store';
import { init } from '../../store/slice/auth.slice';

store.dispatch(init());

export default function App() {
  return (
    <Provider store={store}>
      <MUIThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            maxSnack={10}
            TransitionComponent={Slide}
          >
            <CssBaseline />
            <RouterProvider
              future={{ v7_startTransition: true }}
              router={router}
            />
          </SnackbarProvider>
        </LocalizationProvider>
      </MUIThemeProvider>
    </Provider>
  );
}
